import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import {validateFile} from '../../helpers/Fields';
import * as User from '../../helpers/User';

const $= window.$;

class TechSupport extends Component {
	constructor(props) {
		super(props);
		//alert('im in');
        this.state={


        };

	}


	// componentWillReceiveProps(next) {


	// }

    componentDidMount() {
    	 Common.downTabClose();
    	 //alert('im in');
    }


    sendSupportQuery() {
		  let formData = new FormData();
		  formData.append("user_id", User.UserId());
		  formData.append("subject", this.refs.subject.value);
		  formData.append("query", this.refs.query.value);
			if (this.refs.attachment.files[0] != undefined) {
				formData.append("attachment", this.refs.attachment.files[0]);
			}

		  Common.reactLoader("show", "Please wait...");
		  fetch(Config.domainUrl +"user/supportdesk/query", {
		    method: "POST",
		    headers: {
		      'Accept': 'application/json',
					'Authorization':'Bearer ' +Common.getTokenData()
		    },
		    body: formData
		  }).then((response) => response.json()).then((responseJson) => {
		    Common.reactLoader("hide");
		    if (responseJson.status == 0) {
		      Common.message(responseJson.message, responseJson.errors, "error");
		    } else {
		      Common.message("", responseJson.message, "success");
		      $('form#techsupport')[0].reset();
		    }
		  });
		}




		render() {

			return (
				<section id="contentsection" className="contentarea">
					<div className="inner-title-bg journey-tit-bg">
						<h1><span><img src={process.env.PUBLIC_URL+"/images/support_desk_img.jpg"} alt="" border="0" align="absmiddle" /></span>Tech Support Desk<br /><span className="subtitle">For Technical Queries and Clarifications about the program.</span></h1>
					</div>
					<div>
						<section id="semana-scroll-inner" className="scroll">
							<section className="viewport">
				  				<section style={{top: '0px'}} className="overview">
									<div className="inner-content">
										<form name="techsupport" id="techsupport" method="post"  encType="multipart/form-data" action="#">
											<div className="viewobservers addobservers">
									        	<div className="tabgrey">
									          		<div className="new-observer">
									            		<div className="message-form-left tech-support">
									              			<ul>
									                			<li className="label"><label>To</label></li>
									                			<li className="bluetxt">Tech Support Desk</li>
									                			<div className="clear"></div>
									                			<li className="label"><label>Subject</label></li>
									                			<li><input type="text" ref="subject" className="textbox" /></li>
									                			<div className="clear"></div>
									                			<li className="label"><label>Query</label></li>
									                			<li><textarea ref="query" className="textarea" ></textarea></li>
									                 			<div className="clear"></div>
				                                                	<li className="label"><label>Attachment</label></li>
									                 			<li><input ref="attachment" type="file" style={{border:"none"}} data-valid-types="jpg,jpeg,png,gif" data-max-limit="2097152" onChange={(e)=>validateFile(e)} /><br/>
																<span className="smalltextreg" style={{color:"#ff5400"}}>Maximum upload size is 2MB. (Only JPEG, GIF Formats)</span>
				            								    <input type="button" value="Send" alt="Send" title="Send" onClick={()=>this.sendSupportQuery()}/>
																</li>
											               	</ul>
									        	       	</div>
									                </div>
									        	</div>
									      	</div>
										</form>
									</div>
				 				</section>
				    		</section>
						</section>
					</div>
				</section>

			);
		}
}

export default TechSupport;



// WEBPACK FOOTER //
// ./src/personal_interactions/technical_support/TechSupport.js